import React, { FC } from 'react';
import cx from 'classnames';
import { PropsWithClassName } from '@/types/common';
import { ProductSummary } from '@/types/product';
import Slider from '@/components/Common/Slider';
import { ProductCard } from './ProductCard';
import * as styles from './ProductSlider.module.scss';

type Props = PropsWithClassName<{
  products: ProductSummary[];
}>;

export const ProductSlider: FC<Props> = ({ className, products }) => {
  return (
    <Slider className={cx(styles.main, className)}>
      {products.map((product, index) => (
        <ProductCard key={index} product={product} className={styles.card} />
      ))}
    </Slider>
  );
};
